import { MAIN_PLL_URL } from "../Config/config"
import { CONTENT_CARD_LOCATIONS } from "./braze"

export type DefaultCardData = {
    id: string
    title?: string
    linkText?: string | unknown
    imageUrl?: string
    url?: string
    location?: string
    startTime?: number
    endTime?: number
  }

export const homeCalloutList: DefaultCardData[] = [
    {
        id: `2025-tix-home-card`,
        title: '25 PLL Season Tickets',
        imageUrl: `https://${MAIN_PLL_URL}/wp-content/uploads/2025/03/2025-tix-home-card.webp`,
        startTime: 1743020546,
        endTime: 1754770946,
        url: `https://${MAIN_PLL_URL}/schedule`,
        linkText: 'Buy Tickets',
        location: CONTENT_CARD_LOCATIONS.HOME_SIDE_CARD_1,
    },
    {
        id: `plln-perks-home-card`,
        title: 'Join PLL Nation',
        imageUrl: `https://${MAIN_PLL_URL}/wp-content/uploads/2025/04/PLLNPerks.webp`,
        startTime: 1743020546,
        endTime: 1754770946,
        url: `https://${MAIN_PLL_URL}/pll-nation`,
        linkText: 'Join Now',
        location: CONTENT_CARD_LOCATIONS.HOME_SIDE_CARD_2,
    }
]